import {
  Copyright,
  FooterContainer,
  FooterWrapper,
} from "./FooterStyles";

function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Copyright>&copy; 2025. Mannat Saluja. All Rights Reserved.</Copyright>
      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;
